import { store } from 'index';

function getAuthenticationToken () {
    const state = store.getState();
    return state.auth.access_token;
};

export {
    getAuthenticationToken
}